import { JackpotComponent } from './features/home/jackpot/jackpot.component';
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./core/guards/authentification.guard";
import { LoginGuard } from "./core/guards/login.guard";
import { DefaultLayoutComponent } from "./layout/default-layout.component";
import { LoginComponent } from "./layout/components/login/login.component";
import { RegistrationComponent } from "./layout/components/registration/registration.component";
import { RecoveryComponent } from "./layout/components/recovery/recovery.component";
import { NotFoundComponent } from "./layout/components/not-found/not-found.component";
import { MaintenanceComponent } from "./layout/components/maintenance/maintenance.component";
import { VerificationComponent } from "./layout/components/verification/verification.component";
import { RecoveryConfirmationComponent } from "./layout/components/recovery-confirmation/recovery-confirmation.component";
import { ROUTES } from "./core/constants/routes";
import { AboutAppComponent } from "./features/about-app/about-app.component";
import { TermsAndConditionsComponent } from "./features/terms-and-conditions/terms-and-conditions.component";

export const routes: Routes = [
  {
    path: "", component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    children: [

      {
        path: "",
        redirectTo: ROUTES.HOME_BETTING,
        pathMatch: "full"
      },
      {
        path: ROUTES.PROFILE,
        canActivate: [AuthGuard],
        loadComponent: () => import("./features/profile/profile.component")
          .then(component => component.ProfileComponent)
      },
      {
        path: ROUTES.BAR_CODE,
        canActivate: [AuthGuard],
        loadComponent: () => import("./features/bar-code/bar-code.component")
          .then(component => component.BarCodeComponent)
      },
      {
        path: ROUTES.QR_SCANNER,
        canActivate: [AuthGuard],
        loadChildren: () => import("./features/qr-scanner/qr-code.module")
          .then(m => m.QRCodeModule)
      },
      {
        path: "profil/" + ROUTES.TRANSACTION_HISTORY,
        canActivate: [AuthGuard],
        loadChildren: () => import("./features/history/transaction-history.module")
          .then(component => component.TransactionHistoryModule)
      },
      {
        path: "profil/" + ROUTES.MY_PROFILE,
        canActivate: [AuthGuard],
        loadComponent: () => import("./features/user-info/user-info.component")
          .then(component => component.UserInfoComponent)
      },
      {
        path: "profil/" + ROUTES.PROMO,
        canActivate: [AuthGuard],
        loadComponent: () => import("./features/promotions/components/promotions.component")
          .then(component => component.PromotionsComponent)
      },
      {
        path: "profil/" + ROUTES.GAME_RULES,
        canActivate: [AuthGuard],
        loadComponent: () => import("./features/game-rules/game-rules.component")
          .then(component => component.GameRulesComponent)
      },
      {
        path: "profil/" + ROUTES.ABOUT_APP,
        canActivate: [AuthGuard],
        loadComponent: () => import("./features/about-app/about-app.component")
          .then(component => component.AboutAppComponent)
      },
      {
        path: "profil/" + ROUTES.TERMS_AND_CONDITIONS,
        canActivate: [AuthGuard],
        loadComponent: () => import("./features/terms-and-conditions/terms-and-conditions.component")
          .then(component => component.TermsAndConditionsComponent)
      },
      {
        path: "profil/" + ROUTES.SUPPORT,
        canActivate: [AuthGuard],
        loadComponent: () => import("./features/customer-support/customer-support.component")
          .then(component => component.CustomerSupportComponent)
      },
      {
        path: ROUTES.МАX_VOUCHERS,
        canActivate: [AuthGuard],
        loadChildren: () => import("./features/vouchers/vouchers.routes")
          .then(component => component.VOUCHER_ROUTES)
      },
      // {
      //   path: ROUTES.FREE_TO_PLAY,
      //   canActivate: [AuthGuard],
      //   loadChildren: () => import("./features/home/free-to-play/free-to-play.routes")
      //     .then(component => component.FreeToPlayRoutingModule)
      // },
      {
        path: ROUTES.HOME_CAFE,
        canActivate: [AuthGuard],
        loadChildren: () => import("./features/home/catering/catering.module")
          .then(component => component.CateringModule)
      },

      {
        path: ROUTES.BETTING_JACKPOT,
        canActivate: [AuthGuard],
          loadComponent: () => import("./features/home/jackpot/jackpot.component")
          .then(component => component.JackpotComponent)
      },
      {
        path: ROUTES.BETTING_TASKS,
        canActivate: [AuthGuard],
        loadChildren: () => import("./features/home/betting/betting-tasks.routes")
          .then(component => component.BettingTasksRoutingModule)
      },

    ]
  },

  { path: ROUTES.LOGIN, canActivate: [LoginGuard], component: LoginComponent },
  { path: ROUTES.REGISTER, canActivate: [LoginGuard], component: RegistrationComponent },
  { path: ROUTES.PASSWORD_RECOVERY, canActivate: [LoginGuard], component: RecoveryComponent },
  { path: ROUTES.PASSWORD_RECOVERY_SUBMIT, canActivate: [LoginGuard], component: RecoveryConfirmationComponent },
  { path: ROUTES.NOT_FOUND, component: NotFoundComponent },
  { path: ROUTES.LOGIN_ABOUT_APP, component: AboutAppComponent },
  { path: ROUTES.TERMS_AND_CONDITIONS, component: TermsAndConditionsComponent },
  { path: ROUTES.MAINTENANCE, component: MaintenanceComponent },
  { path: ROUTES.VERIFICATION, component: VerificationComponent },
  { path: "", redirectTo: ROUTES.LOGIN, pathMatch: "full" },
  { path: "**", redirectTo: ROUTES.NOT_FOUND }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
